export default __webpack_public_path__ + "static/media/sc-mail-ico.d5bff85b.svg";